import { createGlobalStyle } from 'styled-components'

import SegoeUIRegular from '@/assets/fonts/segoe-ui.ttf'
import SegoeUISemiBold from '@/assets/fonts/segoe-ui-semibold.ttf'
import SegoeUIBold from '@/assets/fonts/segoe-ui-bold.ttf'

import { Tokens } from './tokens'

export const GlobalStyle = createGlobalStyle`

@font-face {
  font-family: 'Segoe UI';
  font-weight: normal;
  font-style: normal;
  font-display: swap;
  src: url(${SegoeUIRegular}) format('truetype');
}

@font-face {
  font-family: 'Segoe UI';
  font-weight: 600;
  font-style: normal;
  font-display: swap;
  src: url(${SegoeUISemiBold}) format('truetype');
}

@font-face {
  font-family: 'Segoe UI';
  font-weight: 700;
  font-style: normal;
  font-display: swap;
  src: url(${SegoeUIBold}) format('truetype');
}

* {
  margin: 0;
  padding: 0;
  text-decoration: none;
  box-sizing: border-box;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  font-family: 'Segoe UI', sans-serif;
}

html,
body,
#root {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

// Icon
span.i-icon {
  display: flex;
  justify-self: center;
  align-items: center;
}

// Textual Hierarchy
span {
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: ${Tokens.ColorTextSecondary}
}

.react-datepicker {
    font-family: 'Segoe UI', sans-serif;
    border: 1px solid #ddd;
    border-radius: ${Tokens.RadiusInput};
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    background: white;
  }

.react-datepicker__header {
  background-color: ${Tokens.ColorUIPrimary} !important;
  border-bottom: none !important;
  color: white !important;
  padding: 8px 0;
  border-top-left-radius: ${Tokens.RadiusInput};
  border-top-right-radius: ${Tokens.RadiusInput};
}

.react-datepicker__current-month,
.react-datepicker__day-name {
  color: white !important;
  font-weight: 600;
}

.react-datepicker__day {
  color: ${Tokens.ColorTextPrimary};
  &:hover {
    background-color: #e6f7f1 !important;
  }
}

.react-datepicker__day--selected {
  background-color: ${Tokens.ColorUIPrimary} !important;
  color: white !important;
}

.react-datepicker__day--keyboard-selected {
  background-color: rgba(1, 195, 141, 0.5) !important;
}

.react-datepicker__navigation-icon::before {
  border-color: white !important;
  border-width: 2px 2px 0 0;
}

.react-datepicker__triangle {
  border-bottom-color: ${Tokens.ColorUIPrimary} !important;
  &::before {
    border-bottom-color: ${Tokens.ColorUIPrimary} !important;
  }
}

.InputContainer:focus-within {
  border-color: ${Tokens.ColorUIPrimary} !important;
  box-shadow: 0 0 0 2px rgba(1, 195, 141, 0.2);
}

h6 {
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  color: ${Tokens.ColorTextPrimary}
}

h5 {
  font-size: 16px;
  font-weight: 400;
  line-height: 1.5;
  color: ${Tokens.ColorTextPrimary}
}

h4 {
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  color: ${Tokens.ColorTextPrimary}
}

h3 {
  font-size: 18px;
  font-weight: 600;
  line-height: 1.5;
  color: ${Tokens.ColorTextPrimary}
}

h2 {
  font-size: 20px;
  font-weight: 600;
  line-height: 1.5;
  color: ${Tokens.ColorTextPrimary}
}

h1 {
  font-size: 24px;
  font-weight: 600;
  line-height: 1.5;
  color: ${Tokens.ColorTextPrimary};
}

.tertiary-text {
  color: ${Tokens.ColorTextTertiary}
}

.link-text {
  color: ${Tokens.ColorUIPrimary};
  cursor: pointer;
}
`
